export { ReduxWrapper as wrapRootElement } from './src/fragments';
